import axios from 'axios'
import React, { Component } from 'react'
import { Button, Input, Container, Row, Col, Table } from 'reactstrap'

import '../styles/manageUsers.css'

// Get user list
function loadUsers (x) {
  axios({
    method: 'get',
    url: `${process.env.REACT_APP_API_URL}/user`,
    headers: {
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }
  }).then((res) => {
    x.setState({
      users: res.data
    })
  })
}

export default class Users extends Component {
  constructor () {
    super()
    this.state = {
      users: [],
      pseudo: '',
      email: ''
    }
    this.handleChange = this.handleChange.bind(this)
    this.blockUser = this.blockUser.bind(this)
    this.activateUser = this.activateUser.bind(this)
  }

  // Getting user list
  componentWillMount () {
    loadUsers(this)
  }

  // Filter general update module
  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  blockUser (e) {
  // Block user route by updating active prop in DB
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/user/disable/${e.target.id}`,
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then((res) => {
      loadUsers(this)
    })
  }

  activateUser (e) {
    // Block user route by updating active prop in DB
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/user/activate/${e.target.id}`,
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }
    }).then((res) => {
      loadUsers(this)
    })
  }

  render () {
    let filtered = this.state.users
      .filter(user => user.pseudo.toLowerCase().includes(this.state.pseudo.toLowerCase()) === true)
      .filter(user => user.email.toLowerCase().includes(this.state.email.toLowerCase()) === true)

    return (
      <div>
        <Container className={'mT-5'}>
          <Row className={'border-bottom-grey pR-10 pL-10 pB-2 mB-2'}>
            <div>
              <h2>Filtres:</h2>
            </div>
            <Col><Input type='text' name='pseudo' placeholder='Pseudo' onChange={this.handleChange.bind(this)} /></Col>
            <Col><Input type='text' name='email' placeholder='email' onChange={this.handleChange.bind(this)} /></Col>
          </Row>
          <Row>
            <Col className='table-responsive  nopadding'>
              <Table hover>
                <thead className={'bg-ititoca yellow-ititoca'}>
                  <tr>
                    <th>#</th>
                    <th>Pseudo</th>
                    <th>Email</th>
                    <th className={'txtcenter'}>Date d'inscription</th>
                    <th className={'txtcenter'}>Actions</th>
                  </tr>
                </thead>
                {
                  filtered.map(user => {
                    let date = new Date(user.created_date)
                    let year = date.getFullYear(), month = date.getMonth()+1, dt = date.getDate()
                    let index = filtered.indexOf(user) + 1
                    if (dt < 10) { dt = '0' + dt }
                    if (month < 10) { month = '0' + month }
                    return <tbody key={index}>
                      <tr>
                        <td>{index}</td>
                        <td>{user.pseudo}</td>
                        <td>{user.email}</td>
                        <td className={'txtcenter'}>{year+'-' + month + '-'+dt}</td>
                        <td className={'txtcenter'}>
                          <Button id={user._id} color={user.active === true ? 'success' : 'danger'} onClick={user.active === true ? this.blockUser.bind(this): this.activateUser.bind(this)}>{user.active === true ? 'Bloquer' : 'Débloquer'}</Button>
                        </td>
                      </tr>
                    </tbody>
                  })
                }
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageUsers.js